/**
 * Formata um custo de LLM em DÓLARES (US$).
 *
 * IMPORTANTE: o custo vem do Langfuse, que reporta os valores em
 * **dólares americanos (USD)** -- nao em reais. Por isso o prefixo eh
 * ``US$`` (e nao ``R$``). Mantemos a formatacao numerica pt-BR (separador
 * decimal por virgula) para consistencia com o resto da UI.
 *
 * Valores >= US$ 1 usam 2 casas decimais (mais legivel em cards
 * estreitos); micro-custos (< US$ 1) usam ate 4 casas para nao colapsar
 * em ``US$ 0,00``.
 */
export function formatCostUsd(v: number): string {
  const max = v >= 1 ? 2 : 4;
  return `US$ ${v.toLocaleString("pt-BR", {
    minimumFractionDigits: 2,
    maximumFractionDigits: max,
  })}`;
}
